const ItemTypes = Object.freeze(
  [
    { id: 1, name: '製品', value: 'Product' },
    { id: 2, name: '製品以外', value: 'NonProduct' }
  ]
)

export default ItemTypes
